/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} White_Royal_Vole_AbsorbInputs */

const fr_white_royal_vole_absorb = /** @type {(inputs: White_Royal_Vole_AbsorbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si coché, alors le programme sera visible sur le site vitrine.`)
};

/**

* @param {White_Royal_Vole_AbsorbInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const white_royal_vole_absorb = /** @type {((inputs?: White_Royal_Vole_AbsorbInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<White_Royal_Vole_AbsorbInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_white_royal_vole_absorb(inputs)
});